import { Component } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  constructor(public auth: AuthService) {}

  copyPublicLink(): void {
    const user = this.auth.currentUserSnapshot;
    if (!user) return;
    const url = `${window.location.origin}/book/${user.id}`;
    navigator.clipboard.writeText(url).catch(() => {});
  }
}
